import React, { useEffect, useState } from "react";
import { Instagram } from "lucide-react";

/**
 * Sticky bottom-right pill linking to Instagram DMs. Hides on admin +
 * checkout so it never gets in the way of a paying flow. Sessionally
 * dismissable so it can't nag someone forever.
 */
export default function InstagramStamp() {
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem("moto_ig_stamp_dismissed") === "1"; } catch { return false; }
  });

  if (dismissed) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { sessionStorage.setItem("moto_ig_stamp_dismissed", "1"); } catch {}
    setDismissed(true);
  };

  return (
    <a
      href="https://instagram.com/motowear.co.uk"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed z-40 bottom-4 right-4 md:bottom-6 md:right-6 group inline-flex items-center gap-2 pl-3 pr-4 py-2.5 bg-black text-white rounded-full shadow-lg hover:bg-[#FF3B30] transition-colors label-eyebrow text-[11px]"
      data-testid="instagram-stamp"
      aria-label="DM us on Instagram — @motowear.co.uk"
    >
      <Instagram size={16} strokeWidth={2} className="shrink-0" />
      <span className="hidden sm:inline">@motowear · DM us</span>
      <span className="sm:hidden">DM us</span>
      <button
        onClick={dismiss}
        className="ml-1 -mr-1 w-4 h-4 flex items-center justify-center text-white/60 hover:text-white text-[13px] leading-none"
        aria-label="Dismiss Instagram stamp"
        data-testid="instagram-stamp-dismiss"
      >
        ×
      </button>
    </a>
  );
}
